import React, { useState } from 'react';
import { Volume2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { replayButtonAlertAudio } from '../utils/buttonAlertStreamPlayback';

type AlertAudioPlayButtonProps = {
  buttonAlertId?: number | null;
  token: string | null;
  sound?: number | null;
  /** Tamaño del icono Lucide */
  size?: number;
  className?: string;
  iconClassName?: string;
};

function replayErrorMessage(
  reason: 'not_found' | 'unauthorized' | 'empty' | 'play_failed' | 'busy' | 'no_token'
): string {
  switch (reason) {
    case 'unauthorized':
      return 'Sesión expirada; vuelve a iniciar sesión';
    case 'no_token':
      return 'Inicia sesión para reproducir el audio';
    case 'busy':
      return 'Otro audio de alerta se está reproduciendo';
    case 'empty':
      return 'El archivo de audio está vacío o corrupto';
    case 'play_failed':
      return 'No se pudo reproducir el audio';
    case 'not_found':
    default:
      return 'Audio no disponible aún';
  }
}

/**
 * Icono speaker: reproduce el MP3 de la alerta (stream o pregrabado) en cualquier momento.
 */
const AlertAudioPlayButton: React.FC<AlertAudioPlayButtonProps> = ({
  buttonAlertId,
  token,
  sound,
  size = 14,
  className = 'header-notifications-dropdown__item-icon-wrap header-notifications-dropdown__item-icon-wrap--play',
  iconClassName = 'header-notifications-dropdown__item-icon',
}) => {
  const [busy, setBusy] = useState(false);
  const canPlay = buttonAlertId != null && buttonAlertId > 0 && !!token;

  return (
    <button
      type="button"
      className={className}
      disabled={!canPlay || busy}
      title={
        buttonAlertId == null || buttonAlertId <= 0
          ? 'Sin id de alerta'
          : !token
            ? 'Inicia sesión para reproducir el audio'
            : busy
              ? 'Reproduciendo…'
              : 'Reproducir audio de la alerta'
      }
      aria-label="Reproducir audio de la alerta"
      onClick={(e) => {
        e.stopPropagation();
        if (!canPlay || busy || buttonAlertId == null) return;
        setBusy(true);
        void (async () => {
          try {
            const result = await replayButtonAlertAudio(buttonAlertId, token, sound);
            if (!result.ok) {
              toast.error(replayErrorMessage(result.reason));
            }
          } finally {
            setBusy(false);
          }
        })();
      }}
    >
      <Volume2 size={size} className={iconClassName} aria-hidden />
    </button>
  );
};

export default AlertAudioPlayButton;
